import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { config } from 'webpack';

//引数にjsonから取得してきた値を当てる( ja or en)
export const languageInit = () =>{
    i18n.use(initReactI18next).init({
     resources: {
       en: {
         translation: {
           'NFTの保存方法を選択': 'Select how to save NFTs',
           'テスト':'test',
           'ウォレットをお持ちの方':'I have wallet',
           'ウォレットをお持ちでない方':`I don't have a wallet`,
           'ご自分のwalletアドレスを入力ください':'Please enter your wallet address',
           '前回使用したアドレスを表示中です':'The last used address is being displayed',
           '上記ボタンからMetaMaskMobile起動':'Launch MetaMaskMobile from the button above',
           'NFTを受信しています':'Receiving NFT',
           'エラー':'Error',
           '読み込めませんでした':'Could not load.',
           '受け取り画面に戻る':'Return to the pickup screen',
           'NFTの保存完了！':'NFT save complete!',
           'マイページへ移動':'Go to MyPage',
           'マイページ':'MyPage',
           'マーケットプレイスでNFTを見る':'View NFT in the Marketplace',
           'マイウォレットはありません':'No My Wallet',
           'ウォレットのNFTを見る':'View Wallet NFT',
           'ブラウザ内NFTを見る':'View NFT in browser',
           'ブラウザ内NFTを見る(0x.....)':'View NFT in browser (0x.....)',
           'NFTバックアップカードを利用する':'Use NFT backup card',
           'ヘルプ':'help',
           'NFTバックアップカード':'NFT backup card',
           'ブラウザに保存されたNFTを復元する際に使用します':'Used to restore NFTs stored in the browser',
           '誰とも共有しないで下さい':'Do not share with anyone.',
           '無くさないでください':'Please don"t lose it.',
           '復元する場合は、QRコードを読み込んでください':'To restore, please read the QR code',
           '下のボタンで保存できない場合：この画面を保存してください(スクリーンショットなど)':'If you cannot save using the buttons below: Save this screen (e.g. screenshot)',
           'バックアップカードを保存':'Save Backup Card',
           '保存したので進む':'Go next',
           'NFTバックアップカードとは？':'What is NFT Backup Card ?',
           'ブラウザに保存されたNFTを復元するのに必要なカードです。MetaMask等の外部ウォレットのみを使用している場合は不要です。':'This card is required to restore NFTs stored in your browser; not necessary if you are using only an external wallet such as MetaMask.',
           'まだバックアップカードを保存されていない場合は、必ず保存してください。':'If you have not yet saved your backup card, be sure to do so.',
           'ご利用のブラウザにNFTが保存されています':'NFT is stored in your browser',
           'NFTはブラウザに保存されていません':'NFT is not stored in the browser',
           'バックアップカードを保存する':'Save backup card',
           'カードをカメラで読取り復旧':'Read and recover the card with a camera',
           'ウォレット選択':'Select Wallet',
           'スクリーンショットで保存してください':'Save it as a Screenshot',
           'スクリーンショットなどでバックアップカードを保存しましたか？':'Did you save a backup card with a screenshot?',
           'おひとり様の配布上限に達しました！':'The maximum distribution limit per person has been reached!',
           'マイページでNFTをご確認ください':'Please check your NFT on My Page', 
           'マイページで確認':'Check in My Page',   
           '前回の処理が残っています':'The previous process is still in place.',
           '新しいブラウザタブを開いて':'Please open a new browser tab ',
           '受信ページを読み込んでください':'and load the incoming page',
           '新しいブラウザで開く':'Open in a new browser',
           '進む':'go',
           'NFTを受け取る':'get NFT',
           'NFTを移行する':'Move NFT to wallet',
           'ブラウザ':'Browser',
           'メタマスク':'MetaMask',
           'もう一度NFTを受け取る':'Receive NFT again',
           '※他の人に共有しないでください':'Do not share with others',
           'スクリーンショット':'Save it',
           'で':'',
           '保存してください':'as a screenshot',
           'NFTを復元するために必要です':'Required to restore NFT',
           '戻る':'back',
           'ヘルプページ':'HelpPage',
           '待機中':'Loading',
           '注意':'Warning',
           'バックアップカードを必ず保存してください。':'Be sure to save the backup card.',
           '保存しない場合、NFTを復元できません。':'If not saved, the NFT cannot be restored.',
           'NFTの受け取り方法選択':'Select how to receive NFT',
           'NFTを見る':'View NFT',
           '特設サイトに進む':'Go to special site',
           '無効な配布ページです':'Invalid nft distribution page',
           'マイページでNFTをご確認ください!':'Please check your NFTs on the My Page!',
           'ブロックチェーンの異常により':'Due to blockchain anomaly,',
           'NFTの受信に失敗しました':'the receipt of NFT has failed.', 
           '時間を置いて再度お試しください':'Please try again after some time.',  
           '配布期間は終了いたしました':'Distribution period has ended.',
           '使用済みのQRコードです':'QR code has already been used.',   
           'ブロックチェーン上での処理を開始しました':'Processing has started on the blockchain.',
           '完了までしばらくお待ちください':' Please wait for a moment until it is completed.',  
           '普段使用しているブラウザアプリ以外でこのサイトを開いている場合、正常に動作しない場合があります。':'If you are using a browser app other than the one you usually use to open this site, it may not work properly.',
           'Safari , Chrome等のブラウザアプリから本サイトにアクセスし直してください':'Please access this site again from a browser app such as Safari or Chrome.',          
           '受け取ったNFTの確認方法':'How to check the received NFT',
           '下のボタンから公式Lineの追加':'Add official Line from the button below',
           'Line画面からウォレット連携':'Wallet linkage from Line screen',
           '警告':'Warning',
           'エラー!! スマートフォンに対応しています':'Error!! It is compatible with smartphones',
           '配布期間外です':'It is out of the distribution period',
           '受け取ったNFTは':'The received NFT can be viewed in the',
           'αU wallet':'αU wallet',
           'で確認できます':'',
           'Twitterでシェアする':'Share on Twitter',
           'コレクションの上限に達したため、\nこのNFTを受け取ることはできません。':'The maximum number of collections has been reached,\nso you cannot receive this NFT.',
         },
       },
       ja: {
         translation: {
           'NFTの保存方法を選択': 'NFTの保存方法を選択',
           'テスト':'テスト',
           'ウォレットをお持ちの方':'ウォレットをお持ちの方',
           'ウォレットをお持ちでない方':'ウォレットをお持ちでない方',
           'ご自分のwalletアドレスを入力ください':'ご自分のwalletアドレスを入力ください',
           '前回使用したアドレスを表示中です':'前回使用したアドレスを表示中です',
           '上記ボタンからMetaMaskMobile起動':'上記ボタンからMetaMaskMobile起動',
           'NFTを受信しています':'NFTを受信しています',
           'エラー':'エラー',
           '読み込めませんでした':'読み込めませんでした',
           '受け取り画面に戻る':'受け取り画面に戻る',
           'NFTの保存完了！':'NFTの保存完了！',
           'マイページへ移動':'マイページへ移動',
           'マーケットプレイスでNFTを見る':'マーケットプレイスでNFTを見る',
           'マイウォレットはありません':'マイウォレットはありません',
           'ウォレットのNFTを見る':'ウォレットのNFTを見る',
           'ブラウザ内NFTを見る':'ブラウザ内NFTを見る',
           'ブラウザ内NFTを見る(0x.....)':'ブラウザ内NFTを見る(0x.....)',
           'NFTバックアップカードを利用する':'NFTバックアップカードを利用する',
           'ヘルプ':'ヘルプ',
           'NFTバックアップカード':'NFTバックアップカード',
           'ブラウザに保存されたNFTを復元する際に使用します':'ブラウザに保存されたNFTを復元する際に使用します',
           '誰とも共有しないで下さい':'誰とも共有しないで下さい',
           '無くさないでください':'無くさないでください',
           '復元する場合は、QRコードを読み込んでください':'復元する場合は、QRコードを読み込んでください',
           '下のボタンで保存できない場合：この画面を保存してください(スクリーンショットなど)':'下のボタンで保存できない場合：この画面を保存してください(スクリーンショットなど)',
           'バックアップカードを保存':'バックアップカードを保存',
           '保存したので進む':'保存したので進む',
           'NFTバックアップカードとは？':'NFTバックアップカードとは？',
           'ブラウザに保存されたNFTを復元するのに必要なカードです。MetaMask等の外部ウォレットのみを使用している場合は不要です。':'ブラウザに保存されたNFTを復元するのに必要なカードです。MetaMask等の外部ウォレットのみを使用している場合は不要です。',
           'まだバックアップカードを保存されていない場合は、必ず保存してください。':'まだバックアップカードを保存されていない場合は、必ず保存してください。',
           'ご利用のブラウザにNFTが保存されています':'ご利用のブラウザにNFTが保存されています',
           'NFTはブラウザに保存されていません':'NFTはブラウザに保存されていません',
           'バックアップカードを保存する':'バックアップカードを保存する',
           'カードをカメラで読取り復旧':'カードをカメラで読取り復旧',
           'ウォレット選択':'ウォレット選択',
           'スクリーンショットで保存してください':'スクリーンショットで保存してください',
           'スクリーンショットなどでバックアップカードを保存しましたか？':'スクリーンショットなどでバックアップカードを保存しましたか？',
           'おひとり様の配布上限に達しました！':'おひとり様の配布上限に達しました！',
           'マイページでNFTをご確認ください':'マイページでNFTをご確認ください',
           'マイページで確認':'マイページで確認',
           '前回の処理が残っています':'前回の処理が残っています',
           '新しいブラウザタブを開いて':'新しいブラウザタブを開いて',
           '受信ページを読み込んでください':'受信ページを読み込んでください',
           '新しいブラウザで開く':'新しいブラウザで開く',
           '進む':'進む',
           'NFTを受け取る':'NFTを受け取る',
           'NFTを移行する':'NFTを移行する',
           'ブラウザ':'ブラウザ',
           'メタマスク':'メタマスク',
           'もう一度NFTを受け取る':'もう一度NFTを受け取る',
           '※他の人に共有しないでください':'※他の人に共有しないでください',
           'スクリーンショット':'スクリーンショット',
           'で':'で',
           '保存してください':'保存してください',
           'NFTを復元するために必要です':'NFTを復元するために必要です',
           '戻る':'戻る',
           'ヘルプページ':'ヘルプページ',
           '待機中':'待機中',
           '注意':'注意',
           'バックアップカードを必ず保存してください。':'バックアップカードを必ず保存してください。',
           '保存しない場合、NFTを復元できません。':'保存しない場合、NFTを復元できません。',
           'NFTの受け取り方法選択':'NFTの受け取り方法選択',
           'NFTを見る':'NFTを見る',
           '特設サイトに進む':'特設サイトに進む',
           '無効な配布ページです':'無効な配布ページです',
           'マイページでNFTをご確認ください!':'マイページでNFTをご確認ください!',
           'ブロックチェーンの異常により':'ブロックチェーンの異常により',
           'NFTの受信に失敗しました':'NFTの受信に失敗しました', 
           '時間を置いて再度お試しください':'時間を置いて再度お試しください',  
           '配布期間は終了いたしました':'配布期間は終了いたしました', 
           '使用済みのQRコードです':'使用済みのQRコードです',
           'ブロックチェーン上での処理を開始しました':'ブロックチェーン上での処理を開始しました',
           '完了までしばらくお待ちください':'完了までしばらくお待ちください', 
           '普段使用しているブラウザアプリ以外でこのサイトを開いている場合、正常に動作しない場合があります。':'普段使用しているブラウザアプリ以外でこのサイトを開いている場合、正常に動作しない場合があります。',
           'Safari , Chrome等のブラウザアプリから本サイトにアクセスし直してください':'Safari , Chrome等のブラウザアプリから本サイトにアクセスし直してください',      
           '受け取ったNFTの確認方法':'受け取ったNFTの確認方法',
           '下のボタンから公式Lineの追加':'下のボタンから公式Lineの追加',
           'Line画面からウォレット連携':'Line画面からウォレット連携',
           '警告':'警告',
           'エラー!! スマートフォンに対応しています':'エラー!! スマートフォンに対応しています',
           '配布期間外です':'配布期間外です',
           '受け取ったNFTは':'受け取ったNFTは',
           'αU wallet':'αU wallet',
           'で確認できます':'で確認できます',
           'Twitterでシェアする':'Twitterでシェアする',
           'コレクションの上限に達したため、\nこのNFTを受け取ることはできません。':'コレクションの上限に達したため、\nこのNFTを受け取ることはできません。',
         },
       },
     },
     lng: 'ja',
     fallbackLng: 'ja',
     interpolation: { escapeValue: false },
   });
   console.log(`language_init_done`);
}